import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './SaleBadge.scss';

interface SaleBadgeProps {}

const SaleBadge: React.FunctionComponent<SaleBadgeProps> = () => {
  const { t } = useTranslation();

  return (
    <div className={s.root} data-hook="saleBadge">
      <div className={s.title}>{t('sale.badge.title')}</div>
    </div>
  );
};

export default SaleBadge;
